/*
 * @Date: 2021-12-21
 * @LastEditors: 王成安
 * @LastEditTime: 2021-05-27 16:00:41
 * @FilePath: \sany-pub-pay-counter\src\api\modules\commonService.js
 * @description: 导出服务
 */
import Service from './Service';
import _ from 'lodash';
import store from '@/store';

class CommonService extends Service {
    /**
     * common导出
     * @param exportType 导出类型
     * @param query 查询条件
     * @returns {AxiosPromise<any>}
     */
    exportCommonOffline(exportType, query) {
        let params = _.merge({}, query);
        return this.axios.post(`api/pub/v1/offline/common/export/${exportType}`, params, {
            headers: {
                Accept: '*/*',
                ACCOUNT_ID: store.state.user.franchisee.accountId
            }
        });
    }
    /**
     * 离线导出
     * @param exportType 导出类型
     * @param query 查询条件
     * @returns {AxiosPromise<any>}
     */
    exportOffline(exportType, page, query) {
        let params = _.merge({}, page, query);
        return this.axios.get(`api/pub/v1/offline/export/${exportType}`, {
            params: params,
            headers: {
                Accept: '*/*',
                ACCOUNT_ID: store.state.user.franchisee.accountId
            }
        });
    }
    /**
     * 查询导出任务进度
     * @param exportType 导出类型
     * @returns {AxiosPromise<any>}
     */
    exportProgress(exportType) {
        return this.axios.get('api/pub/v1/offline/currentExport', {
            headers: {
                Accept: '*/*',
                ACCOUNT_ID: store.state.user.franchisee.accountId
            }
        });
    }
    /**
     * 获取当前用户可以分页的导出列表
     * @param query
     * @param paging
     * @returns {AxiosPromise<any>}
     */
    getExportList(query, page) {
        return this.axios.get('api/pub/v1/offline/exportLogs', {
            params: _.merge({}, page, query),
            headers: {
                Accept: '*/*',
                ACCOUNT_ID: store.state.user.franchisee.accountId
            }
        });
    }
    /**
     * 下载导出的文件
     * @param id
     * @returns {AxiosPromise<any>}
     */
    exportDownload(id) {
        return this.axios.get(`api/pub/v1/offline/downloadUrl/${id}`, {
            headers: {
                Accept: '*/*',
                ACCOUNT_ID: store.state.user.franchisee.accountId
            }
        });
    }
    /**
     * 取消单个导出任务
     * @param id
     * @returns {AxiosPromise<any>}
     */
    exportCancel(id) {
        return this.axios.put(`api/pub/v1/offline/${id}`, {
            headers: {
                Accept: '*/*',
                ACCOUNT_ID: store.state.user.franchisee.accountId
            }
        });
    }
    /**
     * 获取角色列表
     */
    getGroupList(params) {
        // params.orgId = store.state.user.franchisee.orgId;
        return this.axios.get('api/org/v1/group', { params });
    }
    /**
     * 更新权限对应员工
     * @param params
     */
    updateGroupEmployee(params) {
        params.orgId = store.state.user.franchisee.orgId;
        return this.axios.put(`api/org/v1/employee/set/group/${params.groupId}`, params);
    }
    /**
     * 移除权限对应员工
     * @param params
     */
    removeGroupEmployee(params) {
        params.orgId = store.state.user.franchisee.orgId;
        return this.axios.put(`api/org/v1/employee/set/group/remove/${params.groupId}`, params);
    }
    /**
     * 获取部门列表
     * @param params
     */
    getDepartmentList(params) {
        params.orgId = store.state.user.franchisee.orgId;
        return this.axios.get(`api/org/v1/department`, { params });
    }
    /**
     * 配置业务范围
     * @param params
     * @returns {*}
     */
    bussinesScope(params) {
        return this.axios.post(`api/org/v1/employee/group/bussines/scope`, params);
    }
    /**
     * 获取离职员工列表
     */
    getLeaveEmployees(params) {
        params.orgId = store.state.user.franchisee.orgId;
        return this.axios.get(`api/org/v1/employee/leave`, { params });
    }
    /**
     * 获取员工列表
     */
    getEmployeeGroupList(params) {
        params.orgId = store.state.user.franchisee.orgId;
        return this.axios.get(`api/org/v1/employee/groups`, { params });
    }
    /**
     * 根据id（主责任人id）指定可选员工范围
     */
    findUndertakeUserList(params) {
        return this.axios.get(`api/task/admin/project/projectleadersecretary/findUndertakeUserList`, { params });
    }
    /**
     * 获取员工列表
     */
    getEmployeeList(params) {
        params.orgId = store.state.user.franchisee.orgId;
        return this.axios.get(`api/org/v1/employee`, { params });
    }
    /**
     * 加载组织模块下的资源权限
     * @param params
     */
    getCommonCategoryResources(params) {
        params.bundleId = 'com.sany.truck.shop.web';
        return this.axios.get(`api/org/v1/common/category/resources`, {
            params
        });
    }
    //此处调用的不是支付的服务，没有支付返回结果的固定结构，所以需要重写这个方法
    setupResponseInterceptors() {
        // 响应拦截器
        this.axios.interceptors.response.use(
            response => {
                return response;
            },
            error => {
                const defaultError = error.response || {
                    message: '网络超时',
                    code: 500
                };
                // 身份验证失败
                let isValidateFail = false;

                // 身份验证失败后是否需要跳转
                let redirectWhenFail = false;

                if (error.response && error.response.data) {
                    defaultError.code = error.response.data.code;
                    defaultError.message = error.response.data.message;

                    switch (parseInt(error.response.data.code || 200, 10)) {
                        case 40001:
                            defaultError.message = '该账号已在其它地方登录';
                            isValidateFail = true;
                            redirectWhenFail = true;
                            break;
                        case 40002:
                            defaultError.message = '没有权限访问，请联系管理员';
                            isValidateFail = true;
                            redirectWhenFail = true;
                            break;
                        case 40003:
                            // 优先判断是否被踢出
                            defaultError.message = '用户被停用，请联系管理员';
                            isValidateFail = true;
                            redirectWhenFail = true;
                            break;
                        case 40004:
                            // 优先判断是否被踢出
                            defaultError.message = '登录过期，请重新登录';
                            isValidateFail = true;
                            redirectWhenFail = true;
                            break;
                        case 40006:
                            // 优先判断是否被踢出
                            defaultError.message = '账号认证失败，请联系管理员';
                            isValidateFail = true;
                            redirectWhenFail = true;
                            break;
                        case 44129:
                            defaultError.message = '当前登录已失效';
                            isValidateFail = true;
                            redirectWhenFail = true;
                            break;
                        case 101012:
                            // 优先判断是否被踢出
                            defaultError.message = '无权访问，请联系管理员';
                            isValidateFail = false;
                            redirectWhenFail = false;
                            break;
                        case 101021:
                            // 优先判断是否被踢出
                            defaultError.message = '用户名或密码错误';
                            isValidateFail = true;
                            redirectWhenFail = true;
                            break;
                        case 101022:
                            // 优先判断是否被踢出
                            defaultError.message = '当前登录已失效，请重新登录';
                            isValidateFail = true;
                            redirectWhenFail = true;
                            break;
                        default:
                            break;
                    }

                    if (isValidateFail && redirectWhenFail) {
                        // 身份存在问题并且需要跳转到登录页面
                        window.location.href = `${env.VUE_APP_LOGIN_URL}/#/login`;
                    }
                }

                return Promise.reject(defaultError);
            }
        );
    }
    /**
     * 下载链接
     */
    viewFile(fileKey) {
        return this.axios.get(`api/pub/v1/common/viewFile?fileName=${fileKey}`);
    }
}

const commonService = new CommonService();
export default commonService;
